// extracted by mini-css-extract-plugin
module.exports = {"bgimg":"caretakerlist_bgimg__22sDX"};